import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';
import { type ClassNames, type CustomComponents } from 'react-day-picker';

export const selectedDayClass = '!bg-white-100 !text-grey-900 !rounded-[4px]';

export const calendarClassNames: Partial<ClassNames> = {
    root: 'w-full',
    months: 'relative',
    month: 'w-full',
    month_grid: 'w-full flex flex-col gap-2',
    // A grid rather than flex keeps the columns aligned when a week has
    // trailing days hidden.
    weekdays: 'grid grid-cols-7 gap-2 mb-2',
    weekday:
        'h-9 text-grey-300 text-sm font-medium flex items-center justify-center',
    weeks: 'flex flex-col gap-2',
    week: 'grid grid-cols-7 gap-2',
    day: 'h-[30px] rounded-[4px] text-white-100',
    day_button:
        'w-full h-full font-geist-mono text-xs rounded-[4px] flex items-center justify-center hover:bg-surface-hover-strong transition-colors',
    disabled:
        '[&_button]:pointer-events-none [&_button]:cursor-not-allowed [&_button]:!text-grey-300 [&_button]:!bg-transparent [&_button]:hover:!bg-transparent',
    today: '[&]:!text-brand [&]:!bg-brand/20',
    outside: '!text-grey-200',
    month_caption: 'flex justify-between items-center mb-4 relative',
    caption_label: 'text-white-100 text-sm font-medium pointer-events-none',
    button_previous:
        'text-white-100 flex items-center justify-center hover:text-grey-200 transition-colors aria-disabled:cursor-not-allowed aria-disabled:text-grey-400 aria-disabled:hover:text-grey-400',
    button_next:
        'text-white-100 flex items-center justify-center hover:text-grey-200 transition-colors aria-disabled:cursor-not-allowed aria-disabled:text-grey-400 aria-disabled:hover:text-grey-400',
    chevron: 'fill-current',
    nav: 'absolute flex items-center right-0 top-0 gap-4 z-10',
};

export const calendarComponents: Partial<CustomComponents> = {
    Chevron: ({ orientation, disabled: _disabled, ...props }) =>
        orientation === 'left' ? (
            <CaretLeftIcon className="h-4 w-4" {...props} />
        ) : (
            <CaretRightIcon className="h-4 w-4" {...props} />
        ),
};
